import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { BulkEnableDialogData, BusinessRule } from '../model';
import { bucketValidAutomations } from '../utils';

import { IconComponent } from '@degreed/apollo';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dgx-automations-bulk-enable-modal',
  templateUrl: './automations-bulk-enable-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
})
export class AutomationsBulkEnableModalComponent implements OnInit {
  private readonly dialogRef = inject(DialogRef);
  private readonly translate = inject(TranslateService);
  public readonly data = inject<BulkEnableDialogData>(DIALOG_DATA);

  public enable: boolean = this.data.enable;

  public i18n = this.translate.instant([
    'Automation_EnableAutomations',
    'Automation_DisableAutomations',
    'Automation_BulkEnable_SomeRulesInvalidWarning',
    'Core_Cancel',
    'Core_Enable',
    'Core_Disable',
    'Core_ShowAll',
    'Core_Collapse',
  ]);

  public confirmationMessage: string;
  public actionableAutomations: BusinessRule[];
  public inactionableAutomations: BusinessRule[];
  public showAllInactionable: boolean;

  public ngOnInit() {
    if (!this.enable) {
      this.actionableAutomations = this.data.selectedAutomations;
    } else {
      const { valid, invalid } = bucketValidAutomations(
        this.data.selectedAutomations,
        false,
        this.data.scopeSelectionEnabled
      );
      this.actionableAutomations = valid;
      this.inactionableAutomations = invalid;
    }

    const confirmationString = this.enable
      ? 'Automation_EnableAutomations_Format'
      : 'Automation_DisableAutomations_Format';
    this.confirmationMessage = this.translate.instant(confirmationString, {
      count: this.actionableAutomations.length,
    });
  }

  public onDismiss() {
    this.dialogRef.close();
  }

  public onConfirm() {
    this.dialogRef.close(true);
  }

  public visibleInactionableAutomations() {
    return this.showAllInactionable
      ? this.inactionableAutomations
      : this.inactionableAutomations.slice(0, 5);
  }

  public toggleShowAllInactionable() {
    this.showAllInactionable = !this.showAllInactionable;
  }
}
